/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import '../../../css_android/bot_orders.css'
import { getLocalizedStrings } from '../../custom_views/utils_android/LocalizedStrings';
import DeleteOrderDialog from '../../custom_views/dialogs/DeleteOrderDialog';
import { declension, getOptions, getOptionsIcon, getStartDate } from '../../custom_views/utils_android/Utils';
import ProgressLine from '../../custom_views/ProgressLine';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import OrderMoreTooltip from '../../custom_views/tooltips/OrderMoreTooltip';
import { getPauseBorderStyle } from '../../custom_views/utils_android/StyleHelper';
import { BotOrderStates, getBotAppStatusText, getBotOrderStartDate, getIsOrderCompleted } from '../utils/BotUtils';
import info from '../../custom_views/custom_icons/info.svg';
import more from '../../custom_views/custom_icons/more.svg';
import more_pressed from '../../custom_views/custom_icons/more_pressed.svg';
import play from '../../custom_views/custom_icons/play.svg';
import finished from '../../custom_views/custom_icons/finished.svg';
import pause from '../../custom_views/custom_icons/pause.svg';
import add from '../../custom_views/custom_icons/add.svg';
import android_order from '../../custom_views/custom_icons/android_order.svg';
import ios_order from '../../custom_views/custom_icons/ios_order.svg';
import search_icon from '../../custom_views/custom_icons/search_icon.svg';
import review_icon from '../../custom_views/custom_icons/review.svg';
import third_day_icon from '../../custom_views/custom_icons/third_day.svg';
import likes_up_icon from '../../custom_views/custom_icons/likes_up.svg';
import progress_icon from '../../custom_views/custom_icons/progress.svg';
import { BotApi } from '../../../api/BotApi';

var strings = getLocalizedStrings()
var borderPauseStyle = getPauseBorderStyle()

function BotOrderItem(props) {
    const [isShowDeleteDialog, setShowDeleteDialog] = useState(false)
    const [isShowMore, setShowMore] = useState(false)
    const order = props.order
    useEffect(() => {
       
    }, [])
    // app_icon
    // : 
    // "https://play-lh.googleusercontent.com/X3n-7Kij9gbpTKFSimO8WklUC2nx941RbdRxtbh38GPSpxcRJ2v49-sr_GqvuDwfugY=w240-h480"
    // app_name
    // : 
    // "Подписчики и лайки для Инсты"
    // count_installs
    // : 
    // 200
    // countries
    // : 
    // "[\"FR\",\"DE\",\"PL\"]"
    // createDate
    // : 
    // "2024-07-21T10:52:28.997Z"
    // day_limit
    // : 
    // 50
    // external_id
    // : 
    // "570570"
    // keywords
    // : 
    // "followers for instagram,likes for instagram,likes for instagram for free,likes for instagram free"
    // owner_id
    // : 
    // "5ade03bc3462a93d1cd16e9b"
    // type_os
    // : 
    // "android"
    const openRequestUrl = () => {
        var link = order.keywords == undefined ? (order.type_os == 'ios' ?  'https://itunes.apple.com/ru/app/id' + order.appstore_id : 'https://play.google.com/store/apps/details?id=' + order.bundle ) : order.type_os == 'ios' ? 'https://search.itunes.apple.com/WebObjects/MZSearch.woa/wa/search?media=software&term=' + order.keywords : 'https://play.google.com/store/search?q=' + order.keywords + '&c=apps'
        if (order.type_os != 'android' && window.innerWidth >= 769) {
            link = 'https://itunes.apple.com/ru/app/id' + order.appstore_id;
        }
        window.open(link, '_blank');
    }
  
    const cancelOrder = () => {
        BotApi.cancelOrder(order.external_id, (responseData) => {

        }, () => {})
        props.cancelOrder(order)
    }
    const isOrderCompleted = getIsOrderCompleted(order)
    const orderUrl = "/installs_order_info?id=" + order.external_id
    return (
        <div style={(order.state == BotOrderStates.canceled || order.state == BotOrderStates.waiting) ? borderPauseStyle : {}} className="order_container">
                <div className="padding_12">
                    <div className="top_order">
                        <a className="order_icon hover" rel="noopener noreferrer" target='_blank' href={orderUrl}><img alt='' className="order_icon hover" src={info}/></a>
                        <div onClick={() => window.open(order.type_os == 'ios' ? 'https://itunes.apple.com/ru/app/id' + order.appstore_id : 'https://play.google.com/store/apps/details?id=' + order.bundle, '_blank')} className="order_icon_container">
                            <img alt='' className="order_app_icon" src={order.app_icon}/>
                            <img alt='' className="order_type_icon" src={order.type_os == "android" ? android_order : ios_order}/>
                        </div>
                        <div className="relative">
                            <img alt='' onClick={() => setShowMore(!isShowMore)} className="order_icon hover" src={isShowMore ? more_pressed : more}/>
                            {isShowMore && <OrderMoreTooltip fromBots showIdfa={() => {}} order={order} toogleMore={() => setShowMore(!isShowMore)} deleteOrder={cancelOrder}/>}
                        </div>
                        
                    </div>
                    <a className="order_name hover" rel="noopener noreferrer" target='_blank' href={orderUrl}><p className="order_name hover">{order.app_name ? order.app_name : strings.appBlocked}</p></a>
                    <p className="date_text_order">{getBotOrderStartDate(order)}</p>
                    <div onClick={openRequestUrl} className="center_req hover">
                        <img alt='' className="search_icon" src={search_icon}></img>
                        <p className="order_search_text">{order.keywords == undefined ? strings.withoutReq : order.keywords}</p>
                    </div>

                    <div className="center_icons">
                     
                        {order.day_limit && <img alt='' style={{display : 'flex'}} className="tasks_icon" src={progress_icon}></img>}
                        {order.day_limit ? 
                            <p className="order_search_text top_12">{strings.dayLimit}</p> 
                        : 
                            <p className="order_search_text top_12">{strings.noOptions}</p> 
                        }
                    </div>
                </div>
                
                <div className="control_container">
                    <div className="controlls">
                        <p className="status_text_control">{strings.status}</p>
                        <p className="status_text">{getBotAppStatusText(order)}</p>
                        <img alt='' style={{pointerEvents : 'none'}} className="controll_icon hover" src={isOrderCompleted ? finished : play} />

                    </div>
                 
                </div>
                
                <ProgressLine isOrderCompleted={isOrderCompleted} order={order} count_installed={order.count_complete_installs} max_count_installs={order.count_installs}/>
                <div className="install_container">
                        <div className="flex">
                             <p className="installs">{order.count_complete_installs ? order.count_complete_installs : 0}</p>
                             <p className="installs_desc">{declension(order.count_complete_installs, strings.installs_1, strings.installs_2, strings.installs_5)}</p>
                        </div>
                        <p className="installs_desc">{strings.from + " " + order.count_installs}</p>

                </div>
              {/* {isShowDeleteDialog && <DeleteOrderDialog onCanceledDelete={() => setShowDeleteDialog(false)} onDelete={onDelete}/>}  */}
              
        </div>
            
    )
}

export default BotOrderItem
